export default function withoutSelectionSnapshot(editor, fn) {
  var snapshotSelectionBackup = editor.snapshotSelection;

  editor.snapshotSelection = function () {
    return editor;
  };

  fn(editor);
  editor.snapshotSelection = snapshotSelectionBackup;
  return editor;
}